export default __webpack_public_path__ + "static/industry-community-ab76af3ebfde423df32d4d75adebe9ba.png";